import { useRef, useState } from 'react';
//import { Link } from 'react-router-dom';
import {
    Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Button, useMediaQuery, useTheme
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
//import jsPDF from 'jspdf';
import ServiceReportComponent from '../Jobs/ServiceReport';
import { Base64 } from 'js-base64';


const ServiceReport = ({ serviceReportOpen, handleServiceReportDialogClose, jobData }) => {

    const serviceReportRef = useRef(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    //const doc = new jsPDF('p', 'px', 'a4', true);
    const [loader, setLoader] = useState(true);
    //doc.setFont('helvetica', 'normal');
    //doc.setFontSize('14px');

    // Method 1: html2pdf with better error handling
    const handleGeneratePdf = async () => {
        const element = serviceReportRef.current;

        if (!element) {
            console.error('Service report element not found');
            alert('Error: Report content not available');
            return;
        }

        setIsGenerating(true);
        const filename = 'service_report_' + Base64.encode(jobData.id, true) + '.pdf';

        try {
            // Wait for any async content to load
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Simplified options that work better
            const options = {
                margin: [0, 0, 0, 0],
                filename: filename,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                    logging: true,
                    backgroundColor: '#ffffff'
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait',
                    compress: true
                }
            };

            await html2pdf().set(options).from(element).save();

        } catch (err) {
            console.error('html2pdf Error:', err);
            // Fallback to browser print
            handlePrintFallback();
        } finally {
            setIsGenerating(false);
        }
    };

    // Method 2: Browser print as fallback
    const handlePrintFallback = () => {
        const printWindow = window.open('', '_blank');
        const element = serviceReportRef.current;

        if (!element || !printWindow) {
            alert('Unable to generate PDF. Please try again.');
            return;
        }

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>Service Report</title>
                    <style>
                        body { margin: 0; padding: 20px; font-family: Arial, sans-serif; }
                        @media print {
                            body { margin: 0; }
                            .no-print { display: none !important; }
                        }
                        img { max-width: 100%; height: auto; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                    </style>
                </head>
                <body>
                    ${element.innerHTML}
                    <script>
                        window.onload = function() {
                            window.print();
                            window.close();
                        }
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            maxWidth="md"
            open={serviceReportOpen}
            onClose={handleServiceReportDialogClose}
            scroll='body'
        >

            <DialogTitle className='p-0 no-print'>
                {!loader && <IconButton
                    aria-label="close"
                    onClick={handleServiceReportDialogClose}
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        color: 'black',
                        zIndex: '1000',
                        backgroundColor: 'white',
                        opacity: 0.9
                    }}
                >
                    <CloseIcon />
                </IconButton>}
            </DialogTitle>
            <DialogContent ref={serviceReportRef} className='p-0 m-0 h-100'>
                <ServiceReportComponent jobData={jobData} loader={loader} setLoader={setLoader} />
            </DialogContent >
            <DialogActions sx={{ marginBottom: '25px', paddingRight: '25px' }} className="no-print">
                {!loader && <><Button
                    onClick={handleGeneratePdf}
                    disabled={isGenerating}
                    variant="outlined"
                >
                    {isGenerating ? 'Generating PDF ...' : 'Generate PDF'}
                </Button>
                    <Button onClick={handleServiceReportDialogClose} className='themeholy-btn btn-primary'>Close</Button>
                </>
                }
            </DialogActions>
        </Dialog >
    );
}

export default ServiceReport;